var scope_0 = require('/codebuild/output/src1331782344/src/tyto-www/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e3b9a99d372e2e786191558f6bb29e0b.js').default;
var scope_1 = require('/codebuild/output/src1331782344/src/tyto-www/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e78c9e3ae058c868c63b6befcf651843.js').default;
var scope_2 = require('/codebuild/output/src1331782344/src/tyto-www/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    